import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Button,
  ModalFooter,
  Checkbox,
  Spacer,
  Switch,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { connect } from "react-redux";
import { epl } from "../clientstyles/epl";
import { edp } from "../clientstyles/edp";
import { eplStyles } from "../clientstyles/commonstyles";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import manageStyle from "../NewPages/Dashboardcomponents/Managestyles.module.css";
import { useParams } from "react-router-dom";
import { forceClearAll, forceClearAllWithDOMCleanup, globalAnchorList, rejectAll, rejectItem } from "./AutoSuggestion";


const toPlainName = (key) =>
  key && key.includes("-") ? key.split("-").slice(1).join("-") : key;

const Styling = (props) => {
  const [stylesList, setStyleList] = useState([]);  // always plain names
  const [shownStyles, setShownStyles] = useState({});
  const [selecteddescription, setSelectedDescription] = useState({ name: "" });
  const [searchStyles, setSearchStyles] = useState("");
  const { projectid } = useParams();
  const navigate = useNavigate();


  const prevIsOpenRef = useRef(false);

  useEffect(() => {
    const justOpened = !prevIsOpenRef.current && props.isOpen;
    prevIsOpenRef.current = props.isOpen;
    if (!justOpened) return;

    const projectName = props.projectDetails?.name || "";
    const isInternal = props.projectDetails?.is_internal;
    let subset = {};

    // ── 1. Determine which styles to show (Existing logic) ──
    if (isInternal && projectName.toLowerCase().startsWith("epl")) {
      Object.keys(epl).forEach(k => { subset[k] = { ...epl[k], source: "EPL" }; });
    } else if (isInternal && projectName.toLowerCase().startsWith("edp")) {
      Object.keys(edp).forEach(k => { subset[k] = { ...edp[k], source: "EDP" }; });
    } else {
      const localdata = localStorage.getItem("client");
      const clientArray = localdata ? JSON.parse(localdata) : [];
      const existingEntry = clientArray.find(item => item.id == projectid);
      const savedKeys = existingEntry?.styles || [];

      if (savedKeys.length > 0) {
        subset = savedKeys.reduce((acc, fullKey) => {
          const parts = fullKey.split("-");
          const prefix = parts[0];
          const actualStyleName = parts.slice(1).join("-");
          let styleData = null, sourceLabel = "";

          if (prefix === "EPL" && epl[actualStyleName]) {
            styleData = epl[actualStyleName]; sourceLabel = "EPL";
          } else if (prefix === "EDP" && edp[actualStyleName]) {
            styleData = edp[actualStyleName]; sourceLabel = "EDP";
          } else if (prefix === "Common" && eplStyles[actualStyleName]) {
            styleData = eplStyles[actualStyleName]; sourceLabel = "Common";
          }

          if (styleData) acc[fullKey] = { ...styleData, source: sourceLabel };
          return acc;
        }, {});
      } else {
        Object.keys(eplStyles || {}).forEach(k => { subset[k] = { ...eplStyles[k], source: "Common" }; });
        Object.keys(edp || {}).forEach(k => { subset[k] = { ...edp[k], source: "EDP" }; });
        Object.keys(epl || {}).forEach(k => { subset[k] = { ...epl[k], source: "EPL" }; });
      }
    }

    setShownStyles(subset);

    // ── 2. Load Selection from fixed stylingTools key ──
    const STORAGE_KEY = "stylingTools";
    const savedData = localStorage.getItem(STORAGE_KEY);

    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        // Look for the specific project in the projects array
        const projectEntry = parsed.projects?.find(p => p.id === projectid);

        if (projectEntry && projectEntry.selectedStyles) {
          // If we found saved styles for THIS project, use them
          setStyleList(projectEntry.selectedStyles);
        } else {
          // If no entry for this project, default to select all
          const styleKeys = Object.keys(subset);
          setStyleList(styleKeys.map(toPlainName));
        }
      } catch (e) {
        console.error("Failed to parse styling local storage", e);
        // Fallback on error
        setStyleList(Object.keys(subset).map(toPlainName));
      }
    } else {
      // First time using Styling Tools ever: select all
      const styleKeys = Object.keys(subset);
      setStyleList(styleKeys.map(toPlainName));
    }

    // Set default description for the right panel
    const styleKeys = Object.keys(subset);
    if (styleKeys.length > 0) {
      setSelectedDescription({ name: styleKeys[0], value: subset[styleKeys[0]] });
    }

  }, [props.isOpen, projectid, props.projectDetails]);

  // ── Search: matches key, display name, OR source badge ───────────────────
  const filteredStyles = Object.entries(shownStyles).filter(([keyName, value]) => {
    if (!searchStyles.trim()) return true;
    const q = searchStyles.toLowerCase().trim();
    const matchesWordStart = (text) =>
      (text || "").toLowerCase().split(/[\s_/\-]+/).some(word => word.startsWith(q));
    return (
      matchesWordStart(keyName) ||   // "EPL-PreambleInsertion"
      matchesWordStart(value?.name) ||   // display name
      matchesWordStart(value?.source)     // "EPL", "EDP", "Common"
    );
  });
  console.log("the filtered words are:", filteredStyles);

  // ── Checkbox helpers — all use plain names ────────────────────────────────
  const isStyleChecked = (i) => stylesList.includes(toPlainName(i));

  const updateSelectedStyles = (checked, i) => {
    const plain = toPlainName(i);
    if (checked) {
      setStyleList(prev => [...prev, plain]);
    } else {
      setStyleList(prev => prev.filter(s => s !== plain));
    }
  };
  console.log("the selected styles are one by one :", stylesList);
  const checkAll = (checked) => {
    const filteredPlainNames = filteredStyles.map(([key]) => toPlainName(key));
    if (checked) {
      setStyleList(prev => [...prev, ...filteredPlainNames.filter(n => !prev.includes(n))]);
    } else {
      setStyleList(prev => prev.filter(n => !filteredPlainNames.includes(n)));
    }
  };
  const rejectSuggestion = (item, editor) => {
    if (!item?.startAnchor) return;
    rejectItem(editor, item, props);
  };
  function clearAllMarkers(editor) {
    const session = editor.session;
    const markers = session.getMarkers(true);
    const backgroundMarkers = session.getMarkers(false);

    // Remove front layer markers
    Object.keys(markers).forEach(markerId => {
      session.removeMarker(parseInt(markerId));
    });

    // Remove background layer markers
    Object.keys(backgroundMarkers).forEach(markerId => {
      session.removeMarker(parseInt(markerId));
    });
  }

  const isAllChecked =
    filteredStyles.length > 0 &&
    filteredStyles.every(([key]) => stylesList.includes(toPlainName(key)));

  // ── Submit ────────────────────────────────────────────────────────────────
  // stylesList already holds plain names — save and send directly.
  const handleClick = () => {
    const STORAGE_KEY = "stylingTools";
    const PE_KEY = "peTools";
    const CE_KEY = "ceTools";

    // 1. Save Styling Tools as Active
    const rawStorage = localStorage.getItem(STORAGE_KEY);
    let stylingData = { activestatus: true, projects: [] };

    if (rawStorage) {
      try {
        stylingData = JSON.parse(rawStorage);
      } catch (e) {
        console.error("Error parsing existing styling data");
      }
    }

    stylingData.activestatus = true; // Set this tool to active

    const projectIndex = stylingData.projects.findIndex(p => p.id === projectid);
    const newProjectEntry = { id: projectid, selectedStyles: stylesList };

    if (projectIndex > -1) {
      stylingData.projects[projectIndex] = newProjectEntry;
    } else {
      stylingData.projects.push(newProjectEntry);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(stylingData));

    // 2. DEACTIVATE PE TOOLS
    const savedPe = localStorage.getItem(PE_KEY);
    if (savedPe) {
      try {
        const peData = JSON.parse(savedPe);
        peData.activestatus = false;
        localStorage.setItem(PE_KEY, JSON.stringify(peData));
      } catch (e) { console.error("Error deactivating PE"); }
    }

    // 3. DEACTIVATE CE TOOLS
    const savedCe = localStorage.getItem(CE_KEY);
    if (savedCe) {
      try {
        const ceData = JSON.parse(savedCe);
        ceData.activestatus = false;
        localStorage.setItem(CE_KEY, JSON.stringify(ceData));
      } catch (e) { console.error("Error deactivating CE"); }
    }


    props.toolStyles({ [props.currentClient]: stylesList });
    props.editToolRejected();
    props.clearautosuggestion();
    props.clearAutoSuggestionRejects();
    const editor = props.ace?.current?.editor;
    const allSuggestions = [...(props.autoSuggestions || [])];
    [...allSuggestions].reverse().forEach(item => rejectSuggestion(item, editor));


    if (editor) {
      forceClearAllWithDOMCleanup(editor);
    }

    props.NoSuggestions();
    props.triggerClearAll();
    rejectAll();

    if (!props.showIsChecked) props.autoapplyonoff();
    props.showsuggestion();
    props.showautosuggestion();
    props.setRightController(prev => ({ ...prev, view: "suggestions" }));
    navigate("#suggestions");
    setSearchStyles("");
  };

  return (
    <Modal size={"4xl"} onClose={props.onClose} isOpen={props.isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Styles
          <Spacer />
          <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
            <Checkbox
              isChecked={isAllChecked}
              onChange={e => checkAll(e.target.checked)}
              style={{ marginTop: "10px" }}
            >
              Select All
            </Checkbox>
          </div>
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <div className={manageStyle.searchContainer}>
            <input
              type="text"
              value={searchStyles}
              onChange={e => setSearchStyles(e.target.value)}
              className={manageStyle.searchinput}
              placeholder="Search by name or source (epl, edp, common)…"
            />
            <svg className={manageStyle.searchicon} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z" />
            </svg>
          </div>
        </ModalBody>

        <div className={manageStyle.BothSideContainer}>
          {/* Left: style list */}
          <div className={manageStyle.LeftsideContainer}>
            <div className={manageStyle.ProjectstylePreviewContainer}>
              {filteredStyles.map(([i, value]) => (
                <div
                  key={i}
                  className={`${selecteddescription?.name === i ? manageStyle.currentDiscription : ""} ${manageStyle.projectStyleNames}`}
                >
                  <Checkbox
                    className="checkbox"
                    isChecked={isStyleChecked(i)}
                    onChange={e => updateSelectedStyles(e.target.checked, i)}
                  >
                    <div
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        setSelectedDescription({ name: i, value });
                      }}
                      className={manageStyle.individualstyle}
                      style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "300px" }}
                    >
                      <div style={{ fontSize: "14px", gap: "8px", display: "flex", alignItems: "center" }}>
                        <span style={{
                          fontSize: "10px", fontWeight: "bold", padding: "2px 5px",
                          borderRadius: "4px",
                          backgroundColor: value?.source === "EPL" ? "#ebf8ff" : value?.source === "EDP" ? "#f0fff4" : "#edf2f7",
                          color: value?.source === "EPL" ? "#2b6cb0" : value?.source === "EDP" ? "#2f855a" : "#4a5568",
                          border: "1px solid currentColor", minWidth: "45px", textAlign: "center",
                        }}>
                          {value?.source || "Common"}
                        </span>
                        <div className="stylingTextColor">{value?.name || i}</div>
                      </div>
                      <InfoOutlineIcon />
                    </div>
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>

          {/* Right: description panel */}
          <div className={manageStyle.RightsideContainer}>
            <div className={manageStyle.ProjectdescriptionViewContainer}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <h1 className={manageStyle.Textcolor}>{selecteddescription?.name}</h1>
              </div>
              <div style={{ color: "#222" }}>
                <h3 className={manageStyle.Textcolor}>Description:</h3>
                <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>
                  {selecteddescription?.value?.description || "No description available"}
                </p>
                <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>Before:</p>
                {selecteddescription?.value?.beforeImage && (
                  <img src={process.env.PUBLIC_URL + selecteddescription.value.beforeImage} alt="Before" style={{ paddingBottom: "10px" }} />
                )}
                <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>After:</p>
                {selecteddescription?.value?.afterImage && (
                  <img src={process.env.PUBLIC_URL + selecteddescription.value.afterImage} alt="After" style={{ paddingBottom: "10px" }} />
                )}
              </div>
            </div>
          </div>
        </div>

        <ModalFooter>
          <Button
            onClick={() => {
              if (stylesList.length === 0) {
                props.toast({ title: "Select any style", status: "error", duration: 1000 });
                return;
              }
              handleClick();
              props.onClose();
            }}
            mx={2}
            bg="var(--btn-bg)"
            color="var(--btn-text)"
            _hover={{ bg: "var(--btn-hover)" }}
          >
            Submit
          </Button>
          <Button onClick={() => { props.onClose(); setSearchStyles(""); }}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  editToolStyles: state.toolStyles.function,
  isChecked: state.toolStyles.isChecked,
  showIsChecked: state.autoSuggestion.isChecked,
  showSuggestion: state.editToolRejected.showSuggestion,
  changeclient: state.clientSelect.changeclient,
  autoSuggestions: state.autoSuggestion.suggestions,
});

const mapDispatchToProps = (dispatch) => ({
  eplStyles: (data) => dispatch({ type: "Submit", payload: data }),
  toolStyles: (data) => dispatch({ type: "ToolSubmit", payload: data }),
  editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
  NoSuggestions: () => dispatch({ type: "Dontshowsuggestion" }),
  changeisChecked: () => dispatch({ type: "changeIsChecked" }),
  showautosuggestion: () => dispatch({ type: "toggleautosuggestion" }),
  showsuggestion: () => dispatch({ type: "showsuggestion" }),
  clearautosuggestion: () => dispatch({ type: "clearAutoSuggestion" }),
  clearAutoSuggestionRejects: () => dispatch({ type: "EmptyAutoSuggestionReject" }),
  autoapplyonoff: () => dispatch({ type: "autoapplyonoff" }),
  triggerToolStyles: () => dispatch({ type: "triggerToolStyles" }),
  triggerClearAll: () => dispatch({ type: "triggerClearAll" }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Styling);